const content  = {
    EN: {
      label: 'Search',
      filter: "Filter",
      ID: 'ITEM NO.',  
      Description: 'DESCRIPTION',
      SampleDescription: 'SAMPLE DESCRIPTION',
      Inventory: 'INVENTORY',
      SpecialWeight: 'SPECIAL WEIGHT',
      Composition: 'COMPOSITION',
      Width: 'WIDTH',
      UnitPrice: 'UNIT PRICE',
      Name: 'Name',
      No: 'ID',
      Address: 'Address',
      City: 'City',
      Post_Code: 'Post Code',
      Phone_No: 'Phone No.',
      Orders: 'Outstanding Orders',
      Balance_LCY: 'Balance LCY',
    },
    GR: {
      label: 'Αναζήτηση',
      filter: 'Φίλτρο',
      ID: 'ΚΩΔΙΚΟΣ',
      Description: 'ΠΕΡΙΓΡΑΦΗ',
      SampleDescription: 'ΣΥΝΤΟΜ/ΦΙΑ ΔΕΙΓΜΑΤΟΣ',
      Inventory: 'ΑΠΟΘΕΜΑ',
      SpecialWeight: 'ΕΙΔΙΚΟ ΒΑΡΟΣ',
      Composition: 'ΣΥΝΘΕΣΗ',
      Width: 'ΠΛΑΤΟΣ',
      UnitPrice: 'ΤΙΜΗ ΜΟΝΑΔΑΣ',
      Name: 'ΕΠΩΝΥΜΙΑ',
      No: 'ID',
      Address: 'ΔΙΕΥΘΥΝΣΗ',
      City: 'ΠΟΛΗ',
      Post_Code: 'Τ.Κ.',
      Phone_No: 'ΤΗΛ.',
      Orders: 'ΕΚΚΡΕΜΕΙΣ ΠΑΡΑΓΓΕΛΙΕΣ',
      Balance_LCY: 'ΥΠΟΛΟΙΠΟ',
    },
};

  export default content;


// WEBPACK FOOTER //
// ./src/components/searchbar/content.js